export default "__VITE_ASSET__DmSjDTkl__"